import { usePropsStore } from "@/stores/props";

export const NBH = "NBH";
export const UMB = "UMB";

export function isClient(clientName: string) {
  const propsStore = usePropsStore();
  return clientName === propsStore.clientName;
}
